function calculateCO() {
  if ($("#from-destination").val() && $("#to-destination").val()) {
    setTimeout(function () {
      $("#get_distance_button").trigger("click");
      $(".get_distance.button").removeClass("disabled");
    }, 1000);
  }

  $(".donation-calculate__input.to").on("change", function () {
    $(".get_distance.button").removeClass("disabled");
  });

  $("#get_distance_button").on("click", function () {
    //$("#myRange").val(1);
    //get from airport and to airport
    var fromcode = $("#from-destination").find("option:selected").val();
    var tocode = $("#to-destination").find("option:selected").val();
    var fromname = $("#from-destination").find("option:selected").html();
    var toname = $("#to-destination").find("option:selected").html();
    var rate = $("#calculate-distance-form").attr("data-rate");
    var currency = $("#calculate-distance-form").attr("data-currency");

    //Get distance from api
    $.ajax({
      type: "GET",
      url:
        "https://sitaopen.api.aero/data/v3/airports/distance/" +
        fromcode +
        "/" +
        tocode +
        "?units=km",
      dataType: "json",
      cors: true,
      contentType: "application/javascript",
      secure: true,
      headers: {
        "X-apiKey": "7a9d8c773465a0121836e1d3cced4b6c",
      },

      // error: function (e) {
      //     //alert("An error occurred while processing Xfile");
      //     console.log("reading Failed: ", e);
      // },

      success: function (response) {
        var distance = response.distance.replace(",", "");
        //Make distance a float
        var distance = parseFloat(distance);

        //Increase distance due to longer route compensation
        if (distance < 550) {
          var newDistance = distance + 50;
        } else if (distance >= 550 && distance <= 5500) {
          var newDistance = distance + 100;
        } else if (distance > 5500) {
          var newDistance = distance + 125;
        }

        //Below is not in use, old way of calculation
        //This value is fixed
        //const fuelConsumptionKm = 28.6;

        //This might need to change
        //When changing this; YOU MUST also change in receipt.php and woo_custom.php
        const price = 5;
        //
        // const totalFuelComsumption = fuelConsumptionKm * distance;
        // var totalCost = price * totalFuelComsumption;

        //För att reducera CO2 med 100% så behöver vi även täcka upp för den co2 som biobränsle släpper ut, därav 125%.
        //const actualCost = totalCost * 1.33;

        if (newDistance < 560) {
          var co2PerKm = 0.1086;
        } else if (newDistance >= 560 && newDistance <= 899) {
          var co2PerKm = 0.104;
        } else if (newDistance > 899 && newDistance <= 1299) {
          var co2PerKm = 0.0907;
        } else if (newDistance > 1299 && newDistance <= 1899) {
          var co2PerKm = 0.089;
        } else if (newDistance > 1899 && newDistance <= 3199) {
          var co2PerKm = 0.076;
        } else if (newDistance > 3199 && newDistance <= 6299) {
          var co2PerKm = 0.0655;
        } else if (newDistance > 6299) {
          var co2PerKm = 0.058;
        } else {
          var co2PerKm = 0.058;
        }

        //Totala kostnaden för hela distansen.
        var totalCo2Emission = co2PerKm * newDistance;

        var totalCost = price * totalCo2Emission;

        if (currency !== "SEK") {
          totalCost = totalCost * rate;
        }

        if ($("#return")[0].checked == true) {
          totalCost = totalCost * 2;
          totalCo2Emission = totalCo2Emission * 2;
          var returnTicket = 1;
        } else {
          var returnTicket = 0;
        }

        //Multiply per traveler
        var nrOfTraveles = $("#nrOfTraveles").val();

        totalCost = totalCost * nrOfTraveles;
        totalCo2Emission = totalCo2Emission * nrOfTraveles;

        var roundedTotalCost;
        if (rate !== "SEK") {
          roundedTotalCost = roundToTwoDecimalPlaces(totalCost);
        } else {
          roundedTotalCost = Math.round(totalCost);
        }

        $("#covalue").text(Math.round(totalCo2Emission));
        $(".result-wrapper").addClass("visible");
        $(".make-payment").addClass("visible");
        $("#cost").text(roundedTotalCost);
        $("#cost").attr("data-cost", roundedTotalCost);

        //If percentage gets sent from frontpage, then we have to check the value.
        var percentage = $("#myRange").val();
        fixPercentage(percentage);

        // if ($('input.alg_open_price').length > 0) {
        //   $('input.alg_open_price').val(roundedTotalCost);
        //
        //   if ($('#fgf_custom_button').length > 0) {
        //     var oldUrl = $('#fgf_custom_button').attr('href');
        //     var newUrl = (oldUrl.substring(0, oldUrl.indexOf('price=')));
        //     $('#fgf_custom_button').attr( 'href', newUrl+'price='+roundedTotalCost);
        //     $('#fgf_custom_button').attr( 'data-alg_open_price', roundedTotalCost );
        //   }
        // }

        //Populate url of button with total price on calculation-module
        //The value of the button
        //This is no longer in use since I do the same in recalculate-function
        // $('#payTotalAmount').text(roundedTotalCost+' SEK');
        // var oldUrl = $('#payTotalAmountButton').attr('data-href');
        // var newUrl = oldUrl +  '?from=' + fromcode + '&fromname=' + fromname + '&to=' + tocode + '&toname=' + toname + '&returnticket=' + returnTicket + '&nroftravelers=' + nrOfTraveles;
        // $('#payTotalAmountButton').attr( 'href', newUrl);
      },
    });
  });

  $("#myRange").on("change", function () {
    var percentage = $("#myRange").val();
    fixPercentage(percentage);
  });
}
export default calculateCO;

function fixPercentage(percentage) {
  //Add percentage to text
  $("#rangevalue").text(" " + percentage + "%");
  //function to calculate amount
  reCalcAmount(percentage / 100);
}

function roundToTwoDecimalPlaces(number) {
  return Math.round((number + Number.EPSILON) * 100) / 100;
}

function reCalcAmount(percentage) {
  //Get current cost
  var rate = $("#calculate-distance-form").attr("data-rate");
  var currency = $("#calculate-distance-form").attr("data-currency");
  var currentCost = $("#cost").attr("data-cost");
  var newCost = currentCost * percentage;
  var fromcode = $("#from-destination").find("option:selected").val();
  var tocode = $("#to-destination").find("option:selected").val();
  var fromname = $("#from-destination").find("option:selected").html();
  var toname = $("#to-destination").find("option:selected").html();
  var nrOfTraveles = $("#nrOfTraveles").val();
  var agency = $("#agency").val();

  if ($("#return")[0].checked == true) {
    var returnTicket = 1;
  } else {
    var returnTicket = 0;
  }

  if (currency !== "SEK") {
    $("#cost").text(roundToTwoDecimalPlaces(newCost));
  } else {
    $("#cost").text(Math.round(newCost));
  }

  //Put calculated amount in price for donation-product
  if ($("input.alg_open_price").length > 0) {
    if (currency !== "SEK") {
      $("input.alg_open_price").val(roundToTwoDecimalPlaces(newCost));
    } else {
      $("input.alg_open_price").val(Math.round(newCost));
    }

    if ($("#fgf_custom_button").length > 0) {
      var oldUrl = $("#fgf_custom_button").attr("href");
      var newUrl = oldUrl.substring(0, oldUrl.indexOf("price="));

      if (currency !== "SEK") {
        $("#fgf_custom_button").attr(
          "href",
          newUrl + "price=" + roundToTwoDecimalPlaces(newCost)
        );
        $("#fgf_custom_button").attr(
          "data-alg_open_price",
          roundToTwoDecimalPlaces(newCost)
        );
      } else {
        $("#fgf_custom_button").attr(
          "href",
          newUrl + "price=" + Math.round(newCost)
        );
        $("#fgf_custom_button").attr(
          "data-alg_open_price",
          Math.round(newCost)
        );
      }
    }
  }

  //Add amount on button on front page to go to donation-product
  var oldUrl = $("#payTotalAmountButton").attr("data-href");
  var newUrl =
    oldUrl +
    "?from=" +
    fromcode +
    "&fromname=" +
    fromname +
    "&to=" +
    tocode +
    "&toname=" +
    toname +
    "&returnticket=" +
    returnTicket +
    "&nroftravelers=" +
    nrOfTraveles +
    "&percentage=" +
    percentage * 100;

  if (agency) {
    newUrl += "&agency=" + agency;
  }

  if (currency !== "SEK") {
    $("#payTotalAmount").text(
      roundToTwoDecimalPlaces(newCost) + " " + currency
    );
  } else {
    $("#payTotalAmount").text(Math.round(newCost) + " " + currency);
  }

  $("#payTotalAmountButton").attr("href", newUrl);
}
